export const STEP_THREE_LIST = {
  flowName: 'Suscribir APV',
  back: 'Volver al paso anterior',
  title: 'Paso 3: Empleador',
  subtitle: 'Tu empleador descontará tu APV por planilla cada mes',
  cardTitle: 'Elige un empleador',
  cardSubtitle: 'Selecciona el que descontará el monto de tu APV',
  emailLabel: 'Puedes guardar el correo de tu empleador',
  emailPlaceholder: 'correo@frasal.cl',
  emailButton: 'Guardar',
  emailUpdateButton: 'Actualizar',
  emailError: 'Ingresa un correo válido. Ejemplo: contacto@correo.com',
  submitButton: 'Continuar',
  editTitle: 'Edita tu empleador',
  editBack: 'Volver a confirmar la suscripción',
  editSubmit: 'Guardar cambios',
};

export const EMPLOYER_LABELS = {
  businessName: 'Razón social',
  activity: 'Giro:',
  address: 'Dirección:',
  region: 'Región:',
  commune: 'Comuna:',
  phone: 'Teléfono:',
  rut: 'RUT:',
};
